import { render, staticRenderFns } from "./SkeletonCourseBullet.vue?vue&type=template&id=48e76d68&scoped=true"
import script from "./SkeletonCourseBullet.vue?vue&type=script&lang=js"
export * from "./SkeletonCourseBullet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e76d68",
  null
  
)

export default component.exports